import React from 'react';
import { Typography } from 'fronton-react';
import { useTranslation } from 'react-i18next';
import { DocumentItem } from '../document-item/document-item';
import { additionalTextStyle, contentList, listTitle } from '../product-quality-drawer/styles';
import { Manual, ProductDocument } from '../../types';
import { getDomain } from '../../utils/get-domain';
import { bytesToMegabytes } from 'features/manuals/utils/bytes-to-megabytes';

type Props = {
  manuals: Manual[];
  certificates: ProductDocument[];
  additionalText?: string[];
};

export const CERTIFICATE_DOCUMENTS_LIST_DATA_QA = 'certificate-documents-list';
export const CERTIFICATE_DOCUMENTS_TITLE_DATA_QA = 'certificate-documents-title';
export const MANUAL_ITEM_DATA_QA = 'manual-item';
export const CERTIFICATE_ITEM_DATA_QA = 'certificate-item';
export const ADDITIONAL_TEXT_ITEM_DATA_QA = 'additional-text-item';

export const DocumentsList = ({ manuals, certificates, additionalText }: Props) => {
  const { t } = useTranslation();

  const hasRenderDocuments = !!manuals.length || !!certificates.length;

  return (
    <>
      {hasRenderDocuments && (
        <div data-qa={CERTIFICATE_DOCUMENTS_LIST_DATA_QA} className={contentList}>
          {manuals.map((instruction, index) => (
            <DocumentItem
              key={instruction.url}
              dataQa={`${MANUAL_ITEM_DATA_QA}-${index}`}
              title={
                manuals.length > 1
                  ? `${t('product-info.manuals.manual')} ${index + 1}`
                  : t('product-info.manuals.manual')
              }
              description={instruction.filesize ? `${bytesToMegabytes(instruction.filesize)} MB` : ''}
              href={instruction.url || undefined}
              type="manual"
            />
          ))}

          {!!manuals.length && !!certificates.length && (
            <Typography
              data-qa={CERTIFICATE_DOCUMENTS_TITLE_DATA_QA}
              className={listTitle}
              size="body_accent"
              variant="s"
              color="text-minor"
            >
              {t('product-info.manuals.certificate-title')}
            </Typography>
          )}

          {certificates.map((certificate, index) => (
            <DocumentItem
              key={`${certificate.type}-${certificate.fileName}-${index}`}
              dataQa={`${CERTIFICATE_ITEM_DATA_QA}-${index}`}
              title={certificate.fileName}
              description={getDomain(certificate.fileLink)}
              href={certificate.fileLink}
              type={certificate.type}
            />
          ))}
        </div>
      )}

      {!!additionalText?.length && (
        <div className={additionalTextStyle}>
          {additionalText.map((item, index) => (
            <Typography
              key={item}
              data-qa={`${ADDITIONAL_TEXT_ITEM_DATA_QA}-${index}`}
              size="caption"
              variant="minor"
              color="text-secondary"
            >
              {item}
            </Typography>
          ))}
        </div>
      )}
    </>
  );
};
